import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class Radio extends Component {

  fieldOnChangeHandler(e){
    //console.log('fieldOnChangeHandler',e)
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  render() {
    const {value,optionsList} = this.props;
    //console.log('Radio==',optionsList,value)
    // let attr = setAndGetAttributes(this.props);

    let dispContent = optionsList.map((arr,i) => {
      return(
        <>
          <label className="selectgroup-item mb-1">
              <input type="radio" 
                  name={this.props.fieldKey}
                  value={arr} key={i} 
                  className="selectgroup-input"
                  onChange={e=>this.fieldOnChangeHandler(e)}
                  checked={(arr===value)? true : false}
                />
              <span className="selectgroup-button">{arr}</span>
          </label>          
        </>
      )       
    });
    
    return (
      <Wrp> 
        

        <div className="input-group">  
                  
        {dispContent}        
        </div>
      </Wrp>        
    );
  }
}

Radio.defaultProps = {
  isMandatory:false,
  isEvent:false,
  className: 'form-control',
}

export default Radio;